import StorageService from '../StorageService';
import AuthService from './../AuthService';
import BaseApi from './../BaseApi';

const tokenInterceptor = async (config: any) => {
    const token = StorageService.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

const refreshTokenInterceptor = async (config: any) => {
    const token = StorageService.getRefreshToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

const responseSuccessInterceptor = async (response: any) => response?.data?.data;

const responseErrorInterceptor = async (error: any) => {
    if (isNotAuthorized(error)) {
        try {
            const { token, refreshToken } = await AuthService.refreshToken();
            AuthService.setUserLogged(token, refreshToken,null);
            return BaseApi.request(error.config);
        } catch (error) {
            logout();
        }
    }
    return Promise.reject(error);
};

const responseRefreshTokenErrorInterceptor = async (error: any) => {
    if (isNotAuthorized(error)) {
        logout();
    }
    return Promise.reject(error);
};

const isNotAuthorized = (error: any) => {
    return error.response && error.response.status === 401 && error.response.config.url.indexOf('login') === -1;
}

export const logout = () => {
    StorageService.logOut();

    let returnUrl = encodeURIComponent(
        window.location.href.replace(window.location.origin, "")
    );
    if (returnUrl.indexOf("login") !== -1) {
        returnUrl = "";
    } else {
        returnUrl = `?redirect=${returnUrl}`;
    }
    window.location.href = `${window.location.origin}/login${returnUrl}`;
}

export {
    tokenInterceptor,
    refreshTokenInterceptor,
    responseSuccessInterceptor,
    responseErrorInterceptor,
    responseRefreshTokenErrorInterceptor
}